var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

ProductReviews.Templates['product_reviews_review_list'] = require('../../review_list.html.mustache');

ProductReviews.Views.ReviewCard = require('./product_reviews_review_card');

ProductReviews.Views.ReviewRating = require('./product_reviews_review_rating');

ProductReviews.Views.ReviewList = Backbone.View.extend({
  el: "#product-reviews-list",
  render: function() {
    var fetchedReviews, i, len, prefix, results, review;
    fetchedReviews = this.collection.fetchedReviews();
    if (this.collection.page === 1 || this.collection.displayOptions.showReviewsPage) {
      this.$el.html(ProductReviews.Templates['product_reviews_review_list'].render({
        reviews: _.pluck(fetchedReviews, 'attributes')
      }));
    } else {
      this.$el.append(ProductReviews.Templates['product_reviews_review_list'].render({
        reviews: _.pluck(fetchedReviews, 'attributes')
      }));
    }
    prefix = this.collection.isPreview ? 'preview-' : '';
    results = [];
    for (i = 0, len = fetchedReviews.length; i < len; i++) {
      review = fetchedReviews[i];
      (new ProductReviews.Views.ReviewCard({
        model: review,
        el: "#" + prefix + "review-card-" + review.id
      })).render();
      results.push((new ProductReviews.Views.ReviewRating({
        model: review,
        el: "#" + prefix + "review-rating-" + review.id
      })).render());
    }
    return results;
  }
});

module.exports = ProductReviews.Views.ReviewList;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9wcm9kdWN0X3Jldmlld3MvZnJvbnRlbmQvdmlld3MvcHJvZHVjdF9yZXZpZXdzX3Jldmlld19saXN0LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL21vZHVsZXMvcHJvZHVjdF9yZXZpZXdzL2Zyb250ZW5kL3ZpZXdzL3Byb2R1Y3RfcmV2aWV3c19yZXZpZXdfbGlzdC5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxjQUFBLG1DQUFpQixNQUFNLENBQUMsaUJBQVAsTUFBTSxDQUFDLGlCQUFrQjs7O0VBQzFDLGNBQWMsQ0FBQyxRQUFTOzs7O0VBQ3hCLGNBQWMsQ0FBQyxZQUFhOzs7QUFFNUIsY0FBYyxDQUFDLFNBQVUsQ0FBQSw2QkFBQSxDQUF6QixHQUEwRCxPQUFBLENBQVEsaUNBQVI7O0FBQzFELGNBQWMsQ0FBQyxLQUFLLENBQUMsVUFBckIsR0FBa0MsT0FBQSxDQUFRLCtCQUFSOztBQUNsQyxjQUFjLENBQUMsS0FBSyxDQUFDLFlBQXJCLEdBQW9DLE9BQUEsQ0FBUSxpQ0FBUjs7QUFFcEMsY0FBYyxDQUFDLEtBQUssQ0FBQyxVQUFyQixHQUFrQyxRQUFRLENBQUMsSUFBSSxDQUFDLE1BQWQsQ0FDaEM7RUFBQSxFQUFBLEVBQUksdUJBQUo7RUFFQSxNQUFBLEVBQVEsU0FBQTtBQUNOLFFBQUE7SUFBQSxjQUFBLEdBQWlCLElBQUMsQ0FBQSxVQUFVLENBQUMsY0FBWixDQUFBO0lBQ2pCLElBQUcsSUFBQyxDQUFBLFVBQVUsQ0FBQyxJQUFaLEtBQW9CLENBQXBCLElBQXlCLElBQUMsQ0FBQSxVQUFVLENBQUMsY0FBYyxDQUFDLGVBQXZEO01BQ0UsSUFBQyxDQUFBLEdBQUcsQ0FBQyxJQUFMLENBQVUsY0FBYyxDQUFDLFNBQVUsQ0FBQSw2QkFBQSxDQUE4QixDQUFDLE1BQXhELENBQStEO1FBQUEsT0FBQSxFQUFTLENBQUMsQ0FBQyxLQUFGLENBQVEsY0FBUixFQUF3QixZQUF4QixDQUFUO09BQS9ELENBQVYsRUFERjtLQUFBLE1BQUE7TUFHRSxJQUFDLENBQUEsR0FBRyxDQUFDLE1BQUwsQ0FBWSxjQUFjLENBQUMsU0FBVSxDQUFBLDZCQUFBLENBQThCLENBQUMsTUFBeEQsQ0FBK0Q7UUFBQSxPQUFBLEVBQVMsQ0FBQyxDQUFDLEtBQUYsQ0FBUSxjQUFSLEVBQXdCLFlBQXhCLENBQVQ7T0FBL0QsQ0FBWixFQUhGOztJQUtBLE1BQUEsR0FBWSxJQUFDLENBQUEsVUFBVSxDQUFDLFNBQWYsR0FBOEIsVUFBOUIsR0FBOEM7QUFDdkQ7U0FBQSxnREFBQTs7TUFDRSxDQUFDLElBQUksY0FBYyxDQUFDLEtBQUssQ0FBQyxVQUF6QixDQUFvQztRQUFBLEtBQUEsRUFBTyxNQUFQO1FBQWUsRUFBQSxFQUFJLEdBQUEsR0FBSSxNQUFKLEdBQVcsY0FBWCxHQUF5QixNQUFNLENBQUMsRUFBbkQ7T0FBcEMsQ0FBRCxDQUE2RixDQUFDLE1BQTlGLENBQUE7bUJBQ0EsQ0FBQyxJQUFJLGNBQWMsQ0FBQyxLQUFLLENBQUMsWUFBekIsQ0FBc0M7UUFBQSxLQUFBLEVBQU8sTUFBUDtRQUFlLEVBQUEsRUFBSSxHQUFBLEdBQUksTUFBSixHQUFXLGdCQUFYLEdBQTJCLE1BQU0sQ0FBQyxFQUFyRDtPQUF0QyxDQUFELENBQWlHLENBQUMsTUFBbEcsQ0FBQTtBQUZGOztFQVJNLENBRlI7Q0FEZ0M7O0FBZWxDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLGNBQWMsQ0FBQyxLQUFLLENBQUMifQ==
